import { AfterViewInit, Component, ElementRef, inject, Input, OnDestroy, signal, ViewChild } from '@angular/core';

@Component({
  selector: 'ez-info-popover',
  imports: [],
  templateUrl: './info-popover.component.html',
  styleUrl: './info-popover.component.scss',
})
export class InfoPopoverComponent implements AfterViewInit, OnDestroy {
  private host = inject(ElementRef);

  @Input({ required: true }) popoverText: string;
  @ViewChild('popover') popover: ElementRef<HTMLElement>;
  @ViewChild('icon') icon: ElementRef<HTMLElement>;
  hostHeight: number;
  readonly popoverHeight = signal('0px');
  readonly isHidden = signal(true);
  visibility = 'hidden';
  observer = new MutationObserver(() => {
    this.setHeight();
  });

  ngAfterViewInit() {
    this.observer.observe(this.popover.nativeElement, { attributes: true, attributeFilter: ['style'] });
    this.hostHeight = this.host.nativeElement.offsetHeight;
  }
  ngOnDestroy() {
    this.observer.disconnect();
  }
  toggleVisibility() {
    this.isHidden.update((hidden) => !hidden);
    if (this.isHidden()) {
      this.popoverHeight.set('0px');
    }
  }
  setHeight() {
    this.popoverHeight.set(
      this.popover.nativeElement.offsetHeight + this.hostHeight - this.icon.nativeElement.offsetHeight + 'px',
    );
  }
}
